// Written into the conversion row by the AI backend when the length the client sent does not match what it decoded; the only failure the client can name a remedy for
const AUDIO_LENGTH_MISMATCH_FAILED_MESSAGE = "Error extracting audio length";

const TIME_RETURNED = "Your conversion time has been returned.";

// The body line under a failed conversion's title. Re-exporting only helps when the file's own header is wrong, so the hint is reserved for the backend's length error; every other failure gets the plain retry line.
export const getFailedConversionExplanation = (
  failedMessage: string | null
): string => {
  if (failedMessage === AUDIO_LENGTH_MISMATCH_FAILED_MESSAGE) {
    return `${TIME_RETURNED} If you keep seeing this error with the same file, re-exporting it from your audio software will usually resolve the issue.`;
  }
  return `${TIME_RETURNED} Please try again.`;
};
